import React from 'react';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import RefreshIcon from '@mui/icons-material/Refresh';
import {useTranslation} from 'react-i18next';
import ButtonCustom from "@ui/buttons/buttonCustom/ButtonCustom";
import {sx} from './sx'

interface IProps {
    error: Error
    onReset: () => void
}

const ErrorFallbackCustom = ({error, onReset}: IProps) => {

    const {t} = useTranslation()

    return (
        <Stack sx={sx.root}>
            <ErrorOutlineIcon
                color={'error'}
                sx={sx.icon}
            />

            <Typography variant={'h6'}>
                {t('base.pageCrashedTitle')}
            </Typography>

            <Typography
                variant={'body2'}
                color={'text.secondary'}
            >
                {t('base.pageCrashedText')}
            </Typography>

            {error?.message && <Typography
                variant={'caption'}
                color={'text.disabled'}
                sx={sx.message}
            >
                {error.message}
            </Typography>}

            <ButtonCustom
                variant={'contained'}
                startIcon={<RefreshIcon/>}
                onClick={onReset}
            >
                {t('base.tryAgain')}
            </ButtonCustom>
        </Stack>
    );
};

export default ErrorFallbackCustom;
